export default __webpack_public_path__ + "static/subadaiboldital-ad5425fd7c11c59135288b30d9330d70.ttf";